import React from 'react';
import { BrowserRouter, Route, Switch, Redirect, } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';

import ActivityAnalysis from '../components/progress_reports/activity_analysis/index';
import DiagnosticsIndex from '../components/progress_reports/diagnostic_reports/diagnostics/diagnostics_index';
import Index from '../components/progress_reports/diagnostic_reports/index';
import NotCompleted from '../components/progress_reports/diagnostic_reports/not_completed';

const HashRedirect = () => {
  const { pathname, hash } = window.location;

  if (hash.startsWith('#/')) {
    const cleanHash = hash.slice(1); // Remove the '#' character
    return <Redirect to={cleanHash} />;
  }

  return null;
};

const DiagnosticReports = ({ show_lessons_banner }) => {
  return (
    <BrowserRouter basename="/teachers/progress_reports/diagnostic_reports">
      <Switch>
        <CompatRouter>
          <HashRedirect />
          <Route component={ActivityAnalysis} path="/activity_packs" />
          <Route
            path="/diagnostics"
            render={() => (
              <DiagnosticsIndex lessonsBannerIsShowable={show_lessons_banner} />
            )}
          />
          <Route component={NotCompleted} path="/not_completed" />
          <Route component={Index} path="/" />
        </CompatRouter>
      </Switch>
    </BrowserRouter>
  );
};

export default DiagnosticReports;
